import { createX01Game } from '../shared/x01-game.js';

export default createX01Game({
    id: '501',
    name: '501',
    description: 'The traditional darts game, played as 301, 501, 701 or 1001. Count down from your starting score to exactly zero. Every dart subtracts from your remaining total, but going below zero (or to exactly one) busts and voids the turn - you must check out with a double. Play a single leg, or the best of several legs and sets.'
});
